// extracted by mini-css-extract-plugin
export default {"postOptionsBox":"postOptionsBox__Tj7hY","postOptionsHeader":"postOptionsHeader__IwPf6","postOptions":"postOptions__qEbtf","hint":"hint__xmWa-"};